// src/components/Field/context.ts
import { createContext } from "react";
var FieldContext = createContext({
  id: "",
  name: ""
});
export { FieldContext };